/**
 * Inquiry email configuration mapping for different locales/countries
 *
 * Slovenia (sl): Continental Adria contacts
 * Romania (ro): TODO - Add Romania contacts
 * Bulgaria (bg): TODO - Add Bulgaria contacts
 * English (en): Fallback to Slovenia contacts
 */
export const inquiryConfig = {
  sl: {
    mailTo: 'cod.adria@conti.de',
    cc: [
      'vid.pucko@conti.de',
      'andrej.supe@porsche.si',
      'manuela.toplak@conti.de',
      'katja.crncec@conti.de',
    ],
  },
  bg: {
    mailTo: 'gregor.plohl@conti.de',
    cc: [
      'katya.petrova@porschebulgaria.bg',
      'milen.ivanov@porschebulgaria.bg',
      'alexander.velikov@porschebulgaria.bg',
    ],
  },
  ro: {
    mailTo: 'anca.pintea@conti.de',
    cc: ['roberto-george.pasca@conti.de'],
  },
  en: {
    mailTo: 'cod.adria@conti.de',
    cc: ['vid.pucko@conti.de'],
  },
};

/**
 * Get inquiry email configuration for a given language
 * @param {string} language - Language code (sl, ro, bg, en)
 * @returns {Object} Inquiry configuration object with mailTo and cc properties
 */
export const getInquiryConfig = (language) => {
  return inquiryConfig[language] || inquiryConfig.en;
};

export default inquiryConfig;
